;(function(){
  // 1) Formate une Date selon le locale Shopify
  function formatDate(date) {
    return new Intl.DateTimeFormat(Shopify.locale || navigator.language, {
      day:   '2-digit',
      month: 'long',
      year:  'numeric'
    }).format(date);
  }

  // 2) Calcule startDate et endDate
  function formatDates(minDays, maxDays) {
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() + minDays);
    const end = new Date(today);
    end.setDate(end.getDate() + maxDays);
    return { startDate: formatDate(start), endDate: formatDate(end) };
  }

  // 3) Parcourt tous les <p data-dynamic-date="true"> et injecte le HTML
  function updateShippingDates() {
    document.querySelectorAll('p[data-dynamic-date="true"]').forEach(p => {
      const template = p.getAttribute('data-text');
      const minDays  = parseInt(p.getAttribute('data-min-days'), 10);
      const maxDays  = parseInt(p.getAttribute('data-max-days'), 10);
      if (isNaN(minDays) || isNaN(maxDays)) return;

      const { startDate, endDate } = formatDates(minDays, maxDays);
      // Remplace [start_date] et [end_date] dans la chaîne
      const html = template
        .replace(/\[start_date\]/g, startDate)
        .replace(/\[end_date\]/g,   endDate);

      p.innerHTML = html;
    });
  }

  // 4) Lancer à la fois sur DOMContentLoaded et quand Shopify dispatch 'page:loaded'
  document.addEventListener('DOMContentLoaded', updateShippingDates);
  document.addEventListener('page:loaded',   updateShippingDates);
})();